export const getSavedDirections = (state) => state.directions.directions;
export const getSelectedDirection = (state) => state.directions.selectedDirection;
